import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TabTwo from './ProfessionalHIW'
import Navbar from './Navbar';
import NavbarStudents from "../Dashboard/Navbarlogedin";
import NavbarProfessionals from "../Interviewer/NavbarInterviewer";
import Footer from './Footer';

const Working=()=> {
  const user = JSON.parse(localStorage.getItem("isIAuthenticated"));
  return (
    <>
      {!user?.role ? <Navbar /> : null}
      {user?.role === "Student" ? <NavbarStudents /> : null}
      {user?.role === "Interviewer" ? <NavbarProfessionals /> : null}
      <Box
        sx={{
          typography: "body1",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "white",
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontWeight: "bold",
            mt: 4,
          }}
        >
          How it works
        </Typography>
        <Box sx={{ width: "100%" }}>
          <TabTwo />
        </Box>
      </Box>
      <Footer />
    </>
  );
}
export default Working